// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","941":"27263495"}[chunkId] + "-" + {"245":"8b8ed2539336269e84cb","941":"888e1297dbd9e0ec9fd7"}[chunkId] + ".js";
};